/**
 * æ¯å¦ä¸ºå½æ°
 * @param  {*} fn å¯¹è±¡
 * @return {Boolean}  æ¯å¦å½æ°
 */
import isType from './is-type';
export default (function (value) {
    return isType(value, 'Function');
});
//# sourceMappingURL=is-function.js.map